import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { notificationRepository } from '../services/notificationsRepository';

export const useNotifications = () => {
  const queryClient = useQueryClient();

  // Fetching
  const { data, isLoading, isError } = useQuery({
    queryKey: ['notifications'],
    queryFn: notificationRepository.getNotifications,
  });

  const markReadMutation = useMutation({
    mutationFn: (id: string) => notificationRepository.markAsRead(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });

  const markAllReadMutation = useMutation({
    mutationFn: (ids: Array<string>) =>
      notificationRepository.markAllAsRead(ids),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });

  // 3. Derived State (Calculated on the fly)
  const unreadCount = data?.filter((n) => !n.isRead).length || 0;

  return {
    notifications: data || [],
    isLoading,
    isError,
    unreadCount,
    markAsRead: markReadMutation.mutate,
    markAllAsRead: markAllReadMutation.mutate,
  };
};
